import { Component, OnInit, ViewChild } from '@angular/core';

import { ISettingsState } from './store/settings.state';
import { setSettingsAction } from './store/settings.actions';
import { getSettingsSelectors } from './store/settings.selectors';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { ModalEndComponent } from '../end/components/modal-end/modal-end.component';
import { MatDialog } from '@angular/material/dialog';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { DefaultPricingComponent } from './info/default-pricing/default-pricing.component';
import { initialSettingsState } from './store/settings.reducer';
import { ToastComponent } from 'src/app/components/toast/toast.component';
import { SavedToastComponent } from 'src/app/components/saved-toast/saved-toast.component';
import { IBudgetState } from '../collect-data/components/budget/store/budget.state';
import { getBudgetSelectors } from '../collect-data/components/budget/store/budget.selectors';
import { ISettingState } from './settings-general/store/setting.state';
import { getSettingSelectors } from './settings-general/store/setting.selector';
import { InputToastComponent } from 'src/app/components/input-toast/input-toast.component';
import { HideDeliverablesComponent } from './offer/info/hide-deliverables/hide-deliverables.component';
import { getCookie } from 'src/app/utils/get-cookie';
import { WorkProposalsService } from 'src/app/services/work-proposals.service';
import { IWorkProposals } from '../interfaces/work-proposals.interface';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  formsId: number;
  workProposalData: IWorkProposals = {
    id: 0,
    consultant_project_value: 0,
    followup_service: 0,
    default_pricing: 1,
    discount: 0,
    hide_deliverables: 0,
    installment: 0,
    rba_percentual: 0,
    type_of_investments_id: 0,
    type_of_payments_id: 0
  };

  @ViewChild(ModalEndComponent) modalEndComponent!: ModalEndComponent;

  dataStoreSetting$: Observable<any>;
  dataStoreSetting: ISettingsState;

  dataStoreGeneralSetting$: Observable<any>;
  dataStoreGeneralSetting: ISettingState;

  dataBudgetState$: Observable<IBudgetState>;
  dataBudgetState: IBudgetState;

  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  durationInSeconds = 2;

  constructor(
    private store: Store,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private router: Router,
    private workProposalsService: WorkProposalsService
  ) {
    this.formsId = Number(getCookie('formsId'));
  }

   ngOnInit(): void {
    this.getState();
    this.loadWorkProposalsData();
    this.getGeneralSettingState();
  }

  loadWorkProposalsData() {
    this.workProposalsService
      .getWorkProposalsData(this.formsId)
      .subscribe((response) => {
        this.workProposalData = response;
        this.getState();
      });
  }

  getState(): void {
    this.dataStoreSetting$ = this.store.select(getSettingsSelectors);
    this.dataStoreSetting$.subscribe((value) => {
      this.dataStoreSetting = {
        ...value,
        defaultPricing: this.workProposalData.default_pricing
      };
    });
  }

  getBudgetState() {
    this.dataBudgetState$ = this.store.select(getBudgetSelectors);
    this.dataBudgetState$.subscribe((value) => {
      this.dataBudgetState = { ...value };
    });
  }

  getGeneralSettingState(): void {
    this.dataStoreGeneralSetting$ = this.store.select(getSettingSelectors);
    this.dataStoreGeneralSetting$.subscribe((value) => {
      this.dataStoreGeneralSetting = {
        ...(this.dataStoreGeneralSetting = value),
      };
    });
  }

  setState(data: ISettingsState) {
    this.store.dispatch(setSettingsAction(data));
  }

  setDefaultPricing(): void {
   
    const isDefaultPricing = Boolean(this.workProposalData.default_pricing);
  
    if (isDefaultPricing) {
      this.dataStoreSetting = {
        ...this.dataStoreSetting,
        manualValue: 3000,
        financialConsultantValue: 3000,
        followUpServiceValue: 1200,
        percentValue: 3,
        installments: 12,
        percentualDiscount: 10,
        defaultPricing: true 
      };
    } else {
      this.dataStoreSetting = {
        ...this.dataStoreSetting,
        defaultPricing: false 
      };
    }
    
    this.setState(this.dataStoreSetting);
  }
  
  setHideDeliverables(): void {
    this.dataStoreSetting = {
      ...this.dataStoreSetting,
      hideDeliverables: this.workProposalData.hide_deliverables ? false : true,
    };
    this.setState(this.dataStoreSetting);
  }

  openDialogNewGuide() {
    const dialogRef = this.dialog.open(ModalEndComponent);
    dialogRef.afterClosed().subscribe();
  }

  openDialogDefaultPricing() {
    const dialogRef = this.dialog.open(DefaultPricingComponent);
    dialogRef.afterClosed().subscribe();
  }

  openDialogHideDeliverables() {
    const dialogRef = this.dialog.open(HideDeliverablesComponent);
    dialogRef.afterClosed().subscribe();
  }

  defaultPricingAlert() {
    let title = '';
    if (!this.dataStoreSetting.defaultPricing) {
      title = 'Precificação Padrão ativada';
    } else {
      title = 'Precificação Padrão desativada';
    }

    this._snackBar.openFromComponent(ToastComponent, {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: this.durationInSeconds * 1000,
      panelClass: 'green-snackbar',
      data: { title },
    });
  }

  savedValueAlert() {
    if (
      !this.dataStoreGeneralSetting.clientName ||
      !this.dataStoreGeneralSetting.consultantName
    ) {
      let title = 'Todos os campos obrigatórios devem ser preenchidos';
      this._snackBar.openFromComponent(InputToastComponent, {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        duration: this.durationInSeconds * 1000,
        panelClass: 'alert-snackbar',
        data: { title },
      });
    } else {
      let title = 'Edições salvas';
      this._snackBar.openFromComponent(ToastComponent, {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        duration: this.durationInSeconds * 1000,
        panelClass: 'green-snackbar',
        data: { title },
      });
      this.router.navigate(['/']);
    }
  }

  saveForm(){
    const updateDate: Partial<IWorkProposals> = {
      consultant_project_value: this.dataStoreSetting.financialConsultantValue,
      followup_service: this.dataStoreSetting.followUpServiceValue,
      rba_percentual: this.dataStoreSetting.percentValue,
      installment: Number(this.dataStoreSetting.installments),
      discount: Number(this.dataStoreSetting.percentualDiscount),
      default_pricing: this.workProposalData.default_pricing ? 1 : 0,
      hide_deliverables: this.workProposalData.hide_deliverables ? 1 : 0
    }

    this.workProposalsService.updateWorkProposalsData(this.formsId, this.workProposalData.id, updateDate).subscribe((response)=> {
      let title = 'Edições salvas';
      this._snackBar.openFromComponent(ToastComponent, {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        duration: this.durationInSeconds * 1000,
        panelClass: 'green-snackbar',
        data: { title },
      });
      // this.router.navigate(['/']);
    })
  }
}
